<template>
    <div>
        <el-page-header
            v-if="false"
            @back="goBack"
            title="Geri"
            content="Kontrol Planlama"/>

        <mak-kontrol-planlama/>
    </div>
</template>

<script>
    import MakKontrolPlanlama from '@/components/MakKontrolPlanlama.vue'

    export default {
        name: 'mak-kontrol-planlama-page',
        components: { MakKontrolPlanlama },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
        },
    }
</script>
